




























































































































































import {
  defineComponent, onMounted, reactive, ref, watch,
} from '@vue/composition-api';
import PrettyCheck from 'pretty-checkbox-vue/check';
import { useFormat, useRouter } from '@ideavivat/vivat-2';
import _ from 'lodash';

import agenda from '@/table/agenda';

import {
  getAgendas,
  deleteAgenda,
  deleteAgendas,
  controlAgenda,
  getLive,
} from '@/api';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const Agenda = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
  },
  setup() {
    const { route, routerPersist, router } = useRouter(['searchString', 'searchStatus']);

    const activeAgendaId = ref(-1);
    const loading = ref(true);
    const agendas = ref([]);
    const pagination = ref({
      // eslint-disable-next-line
      current_page: 1,
      total: 0,
    });
    const page = ref(1);
    const sort = ref({ field: 'created_at', order: 'ASC' });
    const searchString = ref('');
    const searchStatus = ref('');

    const callGetLive = async () => {
      loading.value = true;
      activeAgendaId.value = (await getLive(route.value.params.liveId)).active_agenda_id;
    };
    const callGetAgendas = async () => {
      loading.value = true;
      const { data, ...paginatorData } = await getAgendas(
        page.value,
        30,
        sort.value,
        searchString.value,
      );
      agendas.value = data.map((elm: any) => ({
        ...elm,
        _secondaryControls: false,
        _playPauseControls: elm.id !== activeAgendaId.value,
      }));
      pagination.value = paginatorData;
      loading.value = false;
    };

    const pendingSearch = _.debounce(async () => {
      page.value = 1;
      await callGetAgendas();
    }, 500);

    onMounted(async () => {
      await callGetLive();
      await callGetAgendas();
    });

    watch(() => page.value, async (newVal) => {
      // eslint-disable-next-line
      if (newVal !== pagination.value.current_page) {
        await callGetAgendas();
      }
    });
    const handleSortChange = (sortParam: { field: string; order: string }) => {
      sort.value = sortParam;
    };
    watch(() => sort.value, async (newVal, oldVal) => {
      // eslint-disable-next-line
      if (newVal !== oldVal) {
        await callGetAgendas();
      }
    });

    // =========================== //
    // Use with play pause control //
    const playPauseAction = async (id: number | null) => {
      let submitId: number | null = id;
      if (activeAgendaId.value === id) {
        submitId = null;
      }
      activeAgendaId.value = await controlAgenda(route.value.params.liveId, submitId as any);
      await callGetAgendas();
      // votes.value.map((singleVote: any) => {
      //   if (singleVote.id !== latestActiveVoteId) {
      //     return {
      //       ...singleVote,
      //       _playPauseControls: false,
      //     };
      //   }
      //   return {
      //     ...singleVote,
      //     _playPauseControls: true,
      //   };
      // });
    };

    // ==================== //
    // Use with select item //
    const selectedItems: number[] = reactive([]);
    const selectItem = (id: number, status: boolean) => {
      if (status) {
        const removeIndex = selectedItems.findIndex((elm: any) => elm === id);
        if (removeIndex > -1) selectedItems.splice(removeIndex, 1);
      } else {
        selectedItems.push(id);
      }
      const index = agendas.value.findIndex((elm: any) => elm.id === id);
      (agendas.value[index] as any)._secondaryControls = !status;
    };
    const selectAllItems = () => {
      if (selectedItems.length > 0) selectedItems.splice(0, selectedItems.length);
      agendas.value.forEach((elm: any, index: number) => {
        (agendas.value[index] as any)._secondaryControls = true;
        selectedItems.push(elm.id);
      });
    };
    const unselectAllItems = () => {
      selectedItems.splice(0, selectedItems.length);
      agendas.value.forEach((elm: any, index: number) => {
        (agendas.value[index] as any)._secondaryControls = false;
      });
    };

    // Delete fn
    const deleteItemModal = ref(null);
    const deleteItemsModal = ref(null);
    const openDeleteItemModal = (item: any) => {
      (deleteItemModal.value as any).compose({
        id: item.id,
        action: 'ลบ',
        entity: 'กำหนดการ',
        body: `เป็นการลบ<br>${item.name}<br>จากระบบโดยถาวร<br>ไม่สามารถย้อนคืนได้`,
      });
    };
    const deleteItemAction = async (id: number) => {
      const result = await deleteAgenda(id);
      await callGetAgendas();
    };
    const deleteItemsAction = async () => {
      const result = await deleteAgendas(selectedItems);
      await callGetAgendas();
    };

    return {
      agendas,
      agendaTableOptions: agenda,
      activeAgendaId,
      page,
      pagination,
      loading,
      searchString,
      searchStatus,

      pendingSearch,

      sort,
      handleSortChange,
      playPauseAction,

      selectItem,
      selectAllItems,
      selectedItems,
      unselectAllItems,

      openDeleteItemModal,
      deleteItemAction,
      deleteItemsAction,
      deleteItemModal,
      deleteItemsModal,
    };
  },
});

export default Agenda;
